<mat-toolbar >
  <button mat-button (click)="loadMessages()" ><mat-icon>refresh</mat-icon>
{{'MESSAGES.REFRESH'|translate}}</button>
<span class="spacer"></span>
@if (messages.length > 0) {
  <button mat-button (click)="deleteAllMessages()"><mat-icon>delete</mat-icon>
{{'MESSAGES.CLEAR'|translate}}</button>
}

</mat-toolbar>

<div class='list'>
  @for (msg of messages; track msg) {
    <mat-card appearance="outlined" class='example-card'>
      <mat-card-content>
        <div class='alignBar'>
          <span class='timestamp'>
            <mat-icon>mail</mat-icon>
            <label class='timestampText'> {{msg.timeStamp}}</label>
          </span>
          <button mat-button (click)="deleteMessage(msg)">
            <mat-icon>delete</mat-icon>{{'DIALOGS.DELETE'|translate}}
          </button>
        </div>
        @for (line of msg.lines; track line) {
          <div class='msgtext'>&nbsp;{{line}}</div>
        }
      </mat-card-content>
    </mat-card>
  }
</div>
